let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6NkZD")).then(() => parcelRequire('lvNV3'));